const royalHotel = {
  props: {
    dynammicClass: ".c-hotel-royal.dynamicLoading",
    selector: ".hotel-royal",
    strokeColor: "99694C",
    areaColor: "rgba(0,0,0,0)",
    excludedParentSelector: ".icon-switched-JS, .c-hotel-room-list-JS, .meeting-facet, .c-hotel-meeting-room-list__header, .mod--not-royal-brown, .hotel-meetingrooms-icons__item.JS-room-layout, .info-service__wrapper-menu__icons",
  },

  init: function () {
    bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-hotelRoyalColors.css", this.props.dynamicClass);

    document.querySelectorAll(`${this.props.selector} img.c-icon, ${this.props.selector} image.c-icon`).forEach(this.changeIconColor.bind(this));
  },
  changeIconColor: function ($icon) {
    if ($icon.src.startsWith("data:image") && !$icon.closest(this.props.excludedParentSelector)) {
      $icon.src = $icon.src.replace(/(stroke(%\w{2})*)\w{3,6}/g, `$1${this.props.strokeColor}`).replace(/(fill(%\w{2})*)\w{3,6}/g, `$1${this.props.areaColor}`);
    } else if ($icon.src.startsWith("data:image") && ($icon.closest(".meeting-facet") || $icon.closest(".hotel-meetingrooms-icons__item.JS-room-layout"))) {
      $icon.src = $icon.src.replace(/(stroke(%\w{2})*)\w{3,6}/g, `$1${this.props.areaColor}`).replace(/(fill(%\w{2})*)\w{3,6}/g, `$1${this.props.strokeColor}`);
    }
  },
};

export default royalHotel;
